import React, { useEffect, useState } from "react";
import { getLabelName, updateParamsOnChange } from "./Utils";
import { SelectParamsReadOnly } from "./JobReadOnly";
import axiosInstance from "../../../services/axiosService";
import { useTableContext } from "../../../context/TableContext";
import SingleSelectBox from "../../FormComponents/SingleSelectBox";
import { toastError } from "../../../utils/toastUtils";

const GetSelectParamsData = ({
  keyName,
  smId,
  params,
  isReadOnly,
  tableData,
  templateObject,
  device,
  editJobData,
  setParams,
  preRequirements,
  allFieldsObject,
  setEditJobData,
  actId,
  type,
  jobTemplateName
}) => {
  const [options, setOptions] = useState();
  const { getTableTypeData } = useTableContext();

  const [isLoading, setIsLoading] = useState(true);

  const paramsSelector = (e, keyName) => {
    const newParams = { ...params };
    newParams[keyName] = e.target.value;
    updateParamsOnChange(newParams, preRequirements, keyName);
    setParams(newParams);
    setEditJobData(null);
  };
  const frequencyOptions = [
    {
      id: "once",
      name: "once"
    },
    {
      id: "daily",
      name: "daily"
    },
    {
      id: "weekly",
      name: "weekly"
    },
    {
      id: "bi-weekly",
      name: "bi weekly"
    },
    {
      id: "monthly",
      name: "monthly"
    },
    {
      id: "quarterly",
      name: "quarterly"
    }
  ];
  const getAndSetData = async () => {
    // let data = await returnFunctions(key)
    let paramsData = [];
    let newSmId = params.sm_id || params.entity_id || smId;
    let tableType = params.sm_id || params.entity_id ? "statemachine" : type;
    let selectedSm = {};

    if (newSmId) {
      const { data, tableObject } = await getTableTypeData(tableType, newSmId);
      selectedSm = data;
      allFieldsObject.current = { ...allFieldsObject.current, ...tableObject };
    }
    switch (keyName) {
      case "sm_id":
      case "entity_id":
        const newSmObject = tableData.reduce((acc, table) => {
          const { table: singleTable } = table;
          const { table_type: tableType } = singleTable;
          if (!acc[tableType]) acc[tableType] = [];
          acc[tableType] = [...acc[tableType], table.table];
          return acc;
        }, {});
        newSmObject.statemachine = newSmObject.statemachine ? newSmObject.statemachine : [];
        newSmObject.entity = newSmObject.entity ? newSmObject.entity : [];
        const finalData = keyName === "sm_id" ? newSmObject.statemachine : newSmObject.entity;
        paramsData = finalData;
        break;

      case "activity_id":
        let acts =
          selectedSm?.table?.columns_new.filter((col) => col.type === "activity" && col.activity_type === "default") ||
          [];
        templateObject["send_activity_id"] = acts;
        paramsData = acts;
        break;

      case "activity_id_init":
        let activities2 =
          selectedSm?.table?.columns_new.filter((col) => col.type === "activity" && col.activity_type === "init") || [];
        paramsData = activities2;

        templateObject["send_activity_id_init"] = activities2;
        break;
      case "grid_id":
        let state_machine_id, activity_id;
        if (jobTemplateName === "grid_to_sm_fe" || jobTemplateName === "grid_to_sm_bg") {
          state_machine_id = smId;
          activity_id = actId;
        } else {
          state_machine_id = params.sm_id;
          activity_id = params.activity_id_init;
        }

        const { data: initActData } = await axiosInstance.get(
          `/state-machine/${state_machine_id}/activities/${activity_id}`
        );
        const formData = initActData.form.sections[0].fields;
        const richGridData = formData.filter((field) => field.type === "rich-grid");
        const globalRichFields = formData.filter(
          (field) => field.type === "global-data" && field.global_field?.field_type === "rich-grid"
        );
        templateObject["rich_grid_data"] = [...richGridData, ...globalRichFields];
        paramsData = [...richGridData, ...globalRichFields];

        break;

      case "all_activity_id":
        let activities1 = selectedSm?.table?.columns_new.filter((col) => col.type === "activity") || [];
        templateObject["send_all_activity_id"] = activities1;
        paramsData = activities1;
        break;
      case "from_email_connector":
        const { data: emailConnectors } = await axiosInstance.get(`/email_connectors`);
        templateObject["from_email_connector"] = emailConnectors;
        paramsData = emailConnectors;
        break;
      case "frequency":
        paramsData = frequencyOptions;
        break;
      case "detailsview_id":
        const { data: detailViewData } = await axiosInstance.get(`/detailsview`);
        // const detailList = detailViewData[device].filter(
        //   (dv) => dv.data.table_id === smId || dv.table_type === "appuser"
        // );
        // // templateObject["send_detailsview_id"] = detailList;
        // paramsData = detailList;
        paramsData = detailViewData[device];
        break;
      case "recordsview_id":
        const { data: recordviewData } = await axiosInstance.get(`/recordsview`);
        paramsData = recordviewData[device];
        break;
      case "email_template_id":
        const { data: emailData } = await axiosInstance.get(`/email`);
        templateObject["send_email"] = emailData;
        paramsData = emailData;
        break;
      case "sms_template_id":
        const { data: smsData } = await axiosInstance.get(`/sms`);
        templateObject["send_sms"] = smsData;
        paramsData = smsData;
        break;
      case "wa_template_id":
        const { data: whatsappData } = await axiosInstance.get(`/whatsapp`);
        templateObject["send_whatsapp"] = whatsappData;
        paramsData = whatsappData;
        break;
      case "telegram_template_id":
        const { data: telegramData } = await axiosInstance.get(`/telegram`);
        templateObject["send_telegram"] = telegramData;
        paramsData = telegramData;
        break;
      case "document_template_id":
        const { data: prfData } = await axiosInstance.get(`/pdf_template`);
        templateObject["send_pdf"] = prfData;
        paramsData = prfData;
        break;
      case "system_activity_id":
        const { data: sysActData } = await axiosInstance.get(`/state-machine/${newSmId}/activities?search=system`);
        templateObject["send_system_activity"] = sysActData;
        paramsData = sysActData;
        break;
      case "slack_template_id":
        const { data: slackData } = await axiosInstance.get(`/slack`);
        templateObject["send_slack"] = slackData;
        paramsData = slackData;
        break;
      case "googledoc_template_id":
        const { data: googleDocData } = await axiosInstance.get(`/googledoc`);
        templateObject["send_google_doc"] = googleDocData;
        paramsData = googleDocData;
        break;
      case "exceldoc_template_id":
        const { data: excelDocData } = await axiosInstance.get(`/exceldoc`);
        templateObject["send_excel_doc"] = excelDocData;
        paramsData = excelDocData;
        break;
      case "rdbms_form_id":
        const { data: rdbmsForms } = await axiosInstance.get(`/rdbmsform`);
        templateObject["send_rdbms_forms"] = rdbmsForms;
        paramsData = rdbmsForms;
        break;
      case "db_connector":
        const { data: dbConnectors } = await axiosInstance.get(`/dbconnector`);
        templateObject["db_connectors"] = dbConnectors;
        paramsData = dbConnectors;
        break;
      case "select_table":
        const isRdbmsJob = jobTemplateName === "rdbms_update" || jobTemplateName === "rdbms_insert";
        const endpoint = isRdbmsJob ? "/rdbms" : "/postgres";

        const { data } = await axiosInstance.get(endpoint);
        const filterTable = data.map(({ table_name, fields }) => ({ name: table_name, fields }));

        templateObject["send_table"] = data;
        paramsData = filterTable;

        break;
      case "statechange_on_error":
        if (!templateObject["sm_states"]) {
          const { data: states } = await axiosInstance.get(`/state-machine/${smId}/states`);
          templateObject["sm_states"] = states;
          paramsData = states;
        } else {
          paramsData = templateObject["sm_states"];
        }
        break;
      case "mongo_template":
        const { data: mongoTemplate } = await axiosInstance.get(`/mongo-template`);
        const filterMongoTemplate = mongoTemplate.filter((temp) => temp.source_state_machine === newSmId);
        templateObject["mongo_template"] = filterMongoTemplate;
        paramsData = filterMongoTemplate;
        break;
      case "http_template_id":
        const { data: httpTemplate } = await axiosInstance.get(`/http-request-templates`);
        templateObject["http_request_templates"] = httpTemplate;
        paramsData = httpTemplate;
        break;
      case "pro_code_id":
        let { data: smData } = await axiosInstance.get(`/state-machine/${selectedSm.table.id}`);
        smData = smData.config;
        templateObject["pro_code"] = smData.pro_code;
        paramsData = smData.pro_code;

        break;
      case "where_column":
        const tableData1 = templateObject["send_table"];
        const selectedTableData = tableData1.find((table) => table.table_name === params.select_table);
        paramsData = selectedTableData.fields || [];
        break;
      case "gateway":
        const gateWayArray = [
          { id: "RAZORPAY", name: "Razor Pay" },
          { id: "STRIPE", name: "Stripe" }
        ];
        paramsData = gateWayArray;
        break;

      case "ocr_template_id":
        const { data: ocrData } = await axiosInstance.get(`/ocr`);
        templateObject["send_ocr"] = ocrData;
        paramsData = ocrData;
        break;
      case "lookup_field_map":
        let subSM = tableData.find(
          (table) => table.state_machine_id === smId
          // table.state_machine_id === smId
        );
        let activities = subSM?.table?.columns_new.filter((col) => col.type === "activity") || [];
        const smLookups = activities.map((act) => act.items.filter((item) => item.field_type === "lookup")).flat();
        const newSmLookups = smLookups.map((l) => {
          return {
            ...l,
            display: l.display + ` [${l.activity_label}]`
          };
        });
        templateObject["send_lookup_field_map"] = newSmLookups;
        paramsData = newSmLookups;
        break;

      case "name":
        const { data: screenData } = await axiosInstance.get(`/screens`);
        if (!device) {
          toastError("No device found");
          return;
        }
        const filterData = screenData[device].filter((item) => item.name !== "header");
        const finalArray = filterData.map((item) => {
          return {
            id: item.name,
            name: item.name
          };
        });
        templateObject["send_name"] = finalArray;

        paramsData = finalArray;
        break;
      case "desktop_screen":
      case "mobile_screen":
      case "tablet_screen":
        try {
          if (!templateObject["screens_device"]) {
            const { data: allScreenData } = await axiosInstance.get(`/screens`);
            templateObject["screens_device"] = allScreenData;
          }

          const deviceType = keyName.split("_")[0]; // "desktop", "mobile", or "tablet"
          const screenData = templateObject["screens_device"]?.[deviceType] || [];

          const filteredScreenData = screenData.filter((item) => item.name !== "header");
          paramsData = filteredScreenData.map((item) => ({
            id: item.name,
            name: item.name
          }));
        } catch (error) {
          console.error(`Error loading ${keyName} screens:`, error);
          paramsData = [];
        }
        break;

      // case "navigate_with_token":
      //   const navigateTokenOptions = [{ id: true, name: "true" }, { id: false, name: "false" }]
      //   paramsData = navigateTokenOptions;
      //   break;
      case "light_lookup":
        const allActivityOfCurrentSM = selectedSm.table.columns_new.filter((item) => item.type === "activity");
        const allActivityFields = allActivityOfCurrentSM
          .reduce((acc, item) => {
            return [...acc, ...item.items];
          }, [])
          .filter((item) => item.field_type === "lookup-sm");
        const filterLightLookup = {};
        allActivityFields.forEach((element) => {
          if (element.table_id && element.table_id !== newSmId) {
            filterLightLookup[element.id] = {
              id: element.id,
              display: element.display,
              table_id: element.table_id
            };
          }
        });
        templateObject["light_lookup"] = filterLightLookup;
        paramsData = Object.values(filterLightLookup) || [];
        break;
      case "linked_sm_lookup_id":
        const allAct = selectedSm.table.columns_new.filter((item) => item.type === "activity");
        const allLinkedSmFields = allAct
          .reduce((acc, item) => {
            return [...acc, ...item.items];
          }, [])
          .filter((item) => item.field_type === "linked-sm-lookup");
        const filterLinkedLightLookup = {};
        allLinkedSmFields.forEach((element) => {
          if (element.table_id && element.table_id !== newSmId) {
            filterLinkedLightLookup[element.id] = {
              id: element.id,
              display: element.display,
              table_id: element.table_id,
              sub_fields: element.sub_fields
            };
          }
        });
        templateObject["linked_sm_lookup_id"] = filterLinkedLightLookup;
        paramsData = Object.values(filterLinkedLightLookup) || [];
        break;
      default:
        break;
    }
    setOptions(paramsData);
  };
  useEffect(() => {
    setIsLoading(true);
    const fetchData = async () => {
      await getAndSetData();
      if (editJobData) {
        const incomingValue = editJobData.params?.[keyName];
        const currentValue = params?.[keyName];
        if (incomingValue !== undefined && incomingValue !== currentValue) {
          setParams({ ...params, [keyName]: incomingValue });
        }
      }
      setIsLoading(false);
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params[preRequirements[preRequirements.indexOf(keyName) - 1]]]);
  if (isLoading) return;
  return (
    <>
      <SelectParamsData
        keyName={keyName}
        data={options}
        label={getLabelName(keyName)}
        onChange={(e) => paramsSelector(e, keyName)} //e, key
        isReadOnly={isReadOnly}
        params={params}
      />
    </>
  );
};

//individual single select dropdown
const SelectParamsData = ({ keyName, data, label, onChange, isReadOnly, params }) => {
  if (isReadOnly) {
    return <SelectParamsReadOnly label={label} data={data} params={params} keyName={keyName} />;
  }
  // const renderOption = (item) => {
  //   const itemValue = getValue(item);
  //   const itemDisplay = item.table_name || item.name || item.display || item.title || item.label;

  //   return (
  //     <option key={itemValue} value={itemValue}>
  //       {itemDisplay}
  //     </option>
  //   );
  // };
  const getValue = (item) => {
    const idPrioritizedKeys = ["entity_variable_mapping", "lookup_field_map", "sm_variable_mapping", "prefill_mapping"];

    if (idPrioritizedKeys.includes(keyName)) {
      return item.id || item.activity_id || item.name || item.title || item.label;
    }

    return item.activity_id || item.id || item.name || item.title || item.label;
  };

  const renderOptions = data?.map((item) => ({
    id: getValue(item),
    label: item.table_name || item.name || item.display || item.title || item.label
  }));

  return (
    <>
      {data && (
        <div className="builder_form">
          <div className="form_element_wrapper_text">
            <label className="builder_label">Select {label}</label>
            {/* <div className="builder_dropdown_outer">
                <select value={params[keyName] || ""} className="builder_input" onChange={onChange}>
                  <option value="">Select {label}</option>
                  {data.map(renderOption)}
                </select>
              </div> */}
            <SingleSelectBox
              options={renderOptions}
              valueKey="id"
              labelKey="label"
              selectedData={params[keyName] || ""}
              onChange={(selectedOption) => onChange({ target: { value: selectedOption.id } })}
              placeholder={`Select ${label}`}
              isSearch={true}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default GetSelectParamsData;
